import { render, staticRenderFns } from "./btnSeleccionar.vue?vue&type=template&id=4d9fb4eb&"
import script from "./btnSeleccionar.vue?vue&type=script&lang=js&"
export * from "./btnSeleccionar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports